function animationFrameThrottle(a){let b=!1;return function(...c){b||(b=!0,requestAnimationFrame(()=>{b=!1,a.apply(this,c)}))}}export{animationFrameThrottle};